(() => {
  if (window.cthReady) return;
  window.cthReady = true;
  const cfg = window.cthCfg || {};
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (cents) => {
    const v = (Number(cents) || 0) / 100;
    const fix = (d, ts, ds) => { const p = v.toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (p[1] ? ds + p[1] : ''); };
    return String(cfg.money || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return fix(0, ',', '.');
      if (k === 'amount_with_comma_separator') return fix(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fix(0, '.', ',');
      return fix(2, ',', '.');
    });
  };

  const scrim = () => $('[data-cth-scrim]');
  const closeAll = () => {
    $$('.cth-panel').forEach((p) => p.classList.remove('is-open'));
    const m = $('[data-cth-modal]'); if (m) m.hidden = true;
    if (scrim()) scrim().hidden = true;
  };
  const open = (el) => { closeAll(); if (el) el.classList.add('is-open'); if (scrim()) scrim().hidden = false; };

  const renderBag = (cart) => {
    $$('.ctp-bag-count').forEach((el) => { el.textContent = cart.item_count; });
    const body = $('[data-cth-bagbody]'); if (!body) return;
    const foot = $('[data-cth-bagfoot]');
    foot.hidden = !cart.item_count;
    $('[data-cth-subtotal]').textContent = money(cart.total_price);
    if (!cart.item_count) {
      body.innerHTML = '<div class="cth-bag__e"><span>Your bag is empty.</span><a href="' + esc(cfg.all) + '">Start shopping</a></div>';
      return;
    }
    body.innerHTML = cart.items.map((it, i) => '<div class="cth-item">' + (it.image ? '<img src="' + esc(it.image) + '" alt="">' : '') + '<div><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + (it.variant_title ? '<small>' + esc(it.variant_title) + (it.quantity > 1 ? ' · Qty ' + it.quantity : '') + '</small>' : (it.quantity > 1 ? '<small>Qty ' + it.quantity + '</small>' : '')) + '<b>' + esc(money(it.final_line_price)) + '</b><button type="button" data-cth-remove="' + (i + 1) + '">Remove</button></div></div>').join('');
  };
  const refresh = async () => {
    const r = await fetch(cfg.cart + '.js', { headers: { Accept: 'application/json' } });
    if (r.ok) renderBag(await r.json());
  };
  const addToBag = async (id) => {
    const r = await fetch(cfg.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
    if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.description || 'Unavailable'); }
    await refresh();
  };

  /* Header search */
  const toggleSearch = () => {
    const box = $('[data-cth-searchbox]'); if (!box) return;
    box.hidden = !box.hidden;
    const on = !box.hidden;
    $$('[data-cth=search]').forEach((b) => { b.textContent = b.classList.contains('cth-sicon') ? (on ? '×' : '⌕') : (on ? 'Close' : 'Search'); });
    if (on) $('input', box).focus();
  };

  /* Homepage */
  const home = $('[data-cth-home]');
  let setFilter = null; let openQuick = null; let goTo = null;
  if (home) {
    let products = [];
    try { products = JSON.parse($('[data-cth-products]', home).textContent); } catch (e) { products = []; }
    const stars = $('[data-cth-stars]', home);
    if (stars) {
      for (let k = 0; k < 26; k += 1) {
        const s = document.createElement('span');
        s.textContent = '✦';
        s.style.cssText = 'left:' + ((k * 37 + 11) % 100) + '%;top:' + ((k * 53 + 7) % 100) + '%;font-size:' + (8 + (k * 7) % 14) + 'px;color:' + (k % 3 ? '#E2C29B' : '#FFF6E6') + ';animation-duration:' + (2.4 + (k % 5) * 0.7) + 's;animation-delay:' + ((k * 0.41) % 3) + 's';
        stars.appendChild(s);
      }
    }
    const shop = $('#shop', home);
    const cards = $$('[data-card]', shop);
    const fbtns = $$('[data-f]', shop);
    const title = $('[data-cth-title]', shop);
    const count = $('[data-cth-count]', shop);
    const none = $('[data-cth-none]', shop);
    const clear = $('[data-cth-clear]', shop);
    const noneQ = $('[data-cth-noneq]', shop);
    const inF = (c, f) => f === 'All' || (f === 'Sparkle' ? c.dataset.sparkle === 'true' : c.dataset.cat === f);
    fbtns.forEach((b) => { $('span', b).textContent = cards.filter((c) => inF(c, b.dataset.f)).length; });
    let current = 'All';
    goTo = (el) => {
      const off = window.innerWidth < 760 ? 110 : 90;
      const box = $('.page-wrapper');
      const inner = box && getComputedStyle(box).overflowY !== 'visible' && box.scrollHeight > box.clientHeight + 1;
      if (inner) box.scrollTo({ top: el.getBoundingClientRect().top - box.getBoundingClientRect().top + box.scrollTop - off, behavior: 'smooth' });
      else window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - off, behavior: 'smooth' });
    };
    const show = (q) => {
      const qq = (q || '').trim().toLowerCase();
      let n = 0;
      cards.forEach((c) => {
        const on = qq ? (c.dataset.name + ' ' + c.dataset.cat).toLowerCase().includes(qq) : inF(c, current);
        c.hidden = !on; if (on) n += 1;
      });
      fbtns.forEach((b) => b.setAttribute('aria-selected', String(!qq && b.dataset.f === current)));
      title.textContent = qq ? 'Search results' : (current === 'All' ? 'New arrivals' : current);
      count.textContent = n + (n === 1 ? ' piece' : ' pieces') + (qq ? ' for “' + q.trim() + '”' : '');
      none.hidden = n > 0; if (noneQ) noneQ.textContent = q || '';
      clear.hidden = !qq;
      $$('[data-filter]').forEach((a) => {
        const on = !qq && a.dataset.filter === current && current !== 'All';
        if (a.closest('.cth-nav,.cth-chips')) a.classList.toggle('is-on', on);
      });
    };
    setFilter = (f) => { current = f; const i = $('[data-cth-q]'); if (i) i.value = ''; show(''); goTo(shop); };
    fbtns.forEach((b) => b.addEventListener('click', () => { current = b.dataset.f; const i = $('[data-cth-q]'); if (i) i.value = ''; show(''); }));
    clear.addEventListener('click', () => { const i = $('[data-cth-q]'); if (i) i.value = ''; current = 'All'; show(''); });
    $('[data-cth-noneclear]', shop).addEventListener('click', () => clear.click());
    let scrolled = false;
    const qi = $('[data-cth-q]');
    if (qi) qi.addEventListener('input', () => { show(qi.value); if (!scrolled) { scrolled = true; goTo(shop); } if (!qi.value) scrolled = false; });
    show('');

    const modal = $('[data-cth-modal]');
    let mp = null; let sel = [];
    const variant = () => (sel.every((v) => v !== null) ? mp.variants.find((v) => v.o.every((x, i) => x === sel[i])) || null : null);
    const drawModal = () => {
      $$('.cth-opt', modal).forEach((box) => {
        const k = Number(box.dataset.o);
        $('b', box).textContent = sel[k] === null ? 'Select' : sel[k];
        $$('button', box).forEach((b) => {
          const val = b.dataset.v;
          const ok = mp.variants.some((v) => v.a && v.o[k] === val && v.o.every((x, j) => j === k || sel[j] === null || x === sel[j]));
          b.classList.toggle('is-on', sel[k] === val); b.classList.toggle('is-out', !ok);
        });
      });
      const add = $('.cth-modal__add', modal);
      const v = variant();
      const miss = mp.options.findIndex((o, i) => sel[i] === null);
      add.disabled = miss > -1 || !v || !v.a;
      add.textContent = miss > -1 ? 'Select ' + mp.options[miss].toLowerCase() : (v && v.a ? 'Add to bag' : 'Sold out');
    };
    openQuick = (i) => {
      mp = products[i]; if (!mp) return;
      sel = mp.options.map((o, k) => { const vals = [...new Set(mp.variants.map((v) => v.o[k]))]; return vals.length === 1 || /colo/i.test(o) ? (mp.variants.find((v) => v.a) || mp.variants[0]).o[k] : null; });
      const opts = mp.options.map((o, k) => { const vals = [...new Set(mp.variants.map((v) => v.o[k]))]; if (vals.length < 2) return ''; return '<div class="cth-opt" data-o="' + k + '"><span>' + esc(o) + ': <b></b></span><div>' + vals.map((v) => '<button type="button" data-v="' + esc(v) + '">' + esc(v) + '</button>').join('') + '</div></div>'; }).join('');
      modal.innerHTML = '<div class="cth-modal__img"><img src="' + esc(mp.img) + '" alt="' + esc(mp.name) + '"></div><div class="cth-modal__t"><button type="button" class="cth-x" data-cth="close" aria-label="Close">×</button><span class="cth-kick">' + esc(mp.cat) + '</span><h3>' + esc(mp.name) + '</h3><span class="cth-modal__p">' + esc(mp.price) + '</span>' + opts + '<p>See the product page for sizing, materials and delivery details.</p><button type="button" class="cth-modal__add">Add to bag</button><a class="cth-modal__l" href="' + esc(mp.url) + '">View full details</a></div>';
      closeAll(); modal.hidden = false; if (scrim()) scrim().hidden = false;
      drawModal();
    };
    modal.addEventListener('click', async (e) => {
      const pill = e.target.closest('[data-v]');
      if (pill) { const k = Number(pill.closest('.cth-opt').dataset.o); sel[k] = pill.dataset.v; drawModal(); return; }
      if (e.target.closest('.cth-modal__add')) {
        const v = variant(); if (!v) return;
        try { await addToBag(v.id); open($('[data-cth-bag]')); } catch (err) { e.target.textContent = err.message; }
      }
    });
    home.addEventListener('click', async (e) => {
      const q = e.target.closest('[data-quick]');
      if (q) { openQuick(Number(q.closest('[data-i]').dataset.i)); return; }
      const a = e.target.closest('[data-add]');
      if (!a) return;
      const p = products[Number(a.closest('[data-i]').dataset.i)];
      if (p.variants.length > 1) { openQuick(Number(a.closest('[data-i]').dataset.i)); return; }
      a.disabled = true;
      try { await addToBag(p.variants[0].id); a.textContent = 'Added ✓'; a.classList.add('is-added'); } catch (err) { a.textContent = 'Unavailable'; }
      setTimeout(() => { a.textContent = 'Add to bag'; a.classList.remove('is-added'); a.disabled = false; }, 1600);
    });
  }

  document.addEventListener('click', async (e) => {
    const t = e.target.closest('[data-cth]');
    if (t) {
      const k = t.dataset.cth;
      if (k === 'menu') open($('[data-cth-menu]'));
      if (k === 'bag') { open($('[data-cth-bag]')); refresh(); }
      if (k === 'close') closeAll();
      if (k === 'search') toggleSearch();
      return;
    }
    if (e.target.closest('[data-cth-scrim]')) { closeAll(); return; }
    const r = e.target.closest('[data-cth-remove]');
    if (r) {
      r.disabled = true;
      await fetch(cfg.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(r.dataset.cthRemove), quantity: 0 }) });
      refresh();
      return;
    }
    if (home) {
      const f = e.target.closest('[data-filter]');
      if (f) { e.preventDefault(); closeAll(); setFilter(f.dataset.filter); return; }
      const j = e.target.closest('[data-jump]');
      if (j) { const el = $(j.dataset.jump); if (el) { e.preventDefault(); closeAll(); goTo(el); } }
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
})();
